import { MdCheck } from 'react-icons/md'

interface FormStep {
    id: number
    title: string
    description?: string
}

interface FormStepsProps {
    steps: FormStep[]
    currentStep: number
    onStepClick?: (step: number) => void
}

export default function FormSteps({
    steps,
    currentStep,
    onStepClick,
}: FormStepsProps) {
    return (
        <div className="w-full">
            <div className="flex items-center justify-between">
                {steps.map((step, index) => {
                    const isActive = currentStep === step.id
                    const isCompleted = currentStep > step.id
                    const isClickable = onStepClick && (isCompleted || isActive)

                    return (
                        <div key={step.id} className="flex items-center flex-1">
                            <div className="flex flex-col items-center flex-1">
                                <button
                                    type="button"
                                    onClick={() =>
                                        isClickable && onStepClick?.(step.id)
                                    }
                                    disabled={!isClickable}
                                    className={`w-10 h-10 rounded-full flex items-center justify-center font-semibold transition-all ${
                                        isActive
                                            ? 'bg-secondary text-primary-content shadow-lg scale-110'
                                            : isCompleted
                                            ? 'bg-success text-success-content'
                                            : 'bg-base-300 text-base-content/50'
                                    } ${
                                        isClickable
                                            ? 'cursor-pointer hover:scale-105'
                                            : 'cursor-not-allowed'
                                    }`}
                                >
                                    {isCompleted ? (
                                        <MdCheck className="text-xl" />
                                    ) : (
                                        step.id
                                    )}
                                </button>
                                <div className="mt-2 text-center">
                                    <p
                                        className={`text-xs font-medium ${
                                            isActive
                                                ? 'text-secondary'
                                                : isCompleted
                                                ? 'text-success'
                                                : 'text-base-content/50'
                                        }`}
                                    >
                                        {step.title}
                                    </p>
                                    {/*step.description && (
                                        <p className="text-xs text-base-content/60 mt-1">
                                            {step.description}
                                        </p>
                                    )*/}
                                </div>
                            </div>
                            {index < steps.length - 1 && (
                                <div
                                    className={`flex-1 h-1 mx-2 transition-all ${
                                        isCompleted
                                            ? 'bg-success'
                                            : 'bg-base-300'
                                    }`}
                                />
                            )}
                        </div>
                    )
                })}
            </div>
        </div>
    )
}
